module.exports = __webpack_public_path__ + "static/media/blog2.22349f34.png";